(function () {
    'use strict';

    angular.module("imApp").factory("invoiceMakeMultiService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 829,
                    parameters: parms || {}
                });
            },
            listCreateMultiInvoices: function (parms) {
                return $ihttp.post({
                    method: 830,
                    parameters: parms || {}
                });
            },
            createInvoice: function (list) {
                return $ihttp.post({
                    method: 1761,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
